import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  name?: string;
  type?: string;
  image?: string;
  canonicalUrl?: string;
  schema?: any;
}

const SEO: React.FC<SEOProps> = ({
  title = "Envíos de USA a Latinoamérica | elPaket",
  description = "Envía paquetes desde cualquier estado de USA a Venezuela, República Dominicana, Costa Rica, Guatemala y Perú. Recogida UPS, rastreo y entrega puerta a puerta.",
  keywords = "envios de usa a latinoamerica, envios a venezuela, envios a republica dominicana, envios a costa rica, envios a guatemala, envios a peru, recogida ups miami, tracking de paquetes, courier miami, casillero usa",
  name = "elPaket",
  type = "website",
  image = "https://elpaket.com/logo512.png",
  canonicalUrl,
  schema,
}) => {
  const currentUrl =
    canonicalUrl ||
    (typeof window !== "undefined" ? window.location.href : "https://elpaket.com/");

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={name} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={name} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="es_LA" />

      {/* Twitter */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={currentUrl} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
